import React, { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedPackageIds, updateSelectedPackageIds } from 'reducers/misc';
import { Spinner } from 'components/spinner/Spinner';
import { useFetchPackages } from 'hooks/useFetchPackages';
import { AppPath } from 'appConstants';
import { AddFreeTrialApi } from 'api/addFreeTrialApi';
import { useToast } from 'hooks/useToast';
import FormGeneralError from 'components/formComponents/FormGeneralError';

type ChoosePackageFormProps = {
  onSubmit: () => void;
};

export const ChooseFreeTrialPackageForm: React.FC<ChoosePackageFormProps> = ({
  onSubmit,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;

  const selectedPackageIds = useSelector(selectSelectedPackageIds);

  const handleToast = useToast('Your free trial has been set up successfully.');

  const [selectedPackageDetails, setSelectedPackageDetails] = useState<any>(null);
  const [selectedPackageUpdated, setSelectedPackageUpdated] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<string>('');

  const { packages, error } = useFetchPackages(pathname);


  useEffect(() => {
    if (!packages) return;
    setSelectedPackageDetails(packages);
  }, [packages]);  

  useEffect(() => {
    if(selectedPackageUpdated){
      setSelectedPackageDetails(selectedPackageDetails);
      setSelectedPackageUpdated(false);
    }
  }, [selectedPackageUpdated]);   


  const selectPackage = (packageId: number, subject_index: number) => {
    let selectedPackageDetailsCopy = selectedPackageDetails;

    const packageSelected: boolean = selectedPackageDetailsCopy[subject_index].selected === undefined ? true : 
      !selectedPackageDetailsCopy[subject_index].selected;

    selectedPackageDetailsCopy[subject_index].selected = packageSelected;

    setSelectedPackageDetails(selectedPackageDetailsCopy);
    setSelectedPackageUpdated(true);



    let packageIdList: any = selectedPackageIds;
    let packageIdRemoved: boolean = false;

    for(let i = 0; i < packageIdList.length; i++){
      if(packageIdList[i] === packageId){
        packageIdList.splice((i - 1), 1);
        packageIdRemoved = true;
      }
    }

    if(!packageIdRemoved){
      packageIdList.push(packageId);
    }

    dispatch(updateSelectedPackageIds(packageIdList));
  };

  const onContinue = async () => {
    if (selectedPackageIds.length === 0) return;

    setSubmitError('');
    const result = await AddFreeTrialApi.submitFreeTrialPackages(
      selectedPackageIds
    );

    if (!result.error) {
      dispatch(updateSelectedPackageIds([]));
      handleToast();
      onSubmit();
    }
    if (result.error) {
      setSubmitError(result.error.message);
    }
  };

  if ((!selectedPackageDetails || (selectedPackageDetails && selectedPackageDetails.length === 0)) && !error && !submitError) {
    return (
      <div
        style={{
          minHeight: ' calc(100vh - 300px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (error || submitError) {
    return <FormGeneralError message={error || submitError} />;
  }  

  return (
    <>
      <div className="LineSpacer3"></div>

      <div className="PricingColRow FreeTrial">
        <div className="PCRowInner SmGap">
          <div className="LeftCol">
            {selectedPackageDetails && selectedPackageDetails.length > 0 &&
              <>
                {selectedPackageDetails.map((packageObj: any, index: number) => {
                  return (
                    <div className="SubSelectOptRow" key={"Sub_Opt_Row_" + index}>
                      <label className={"SubOption" + (packageObj.selected ? " Checked" : "")}>
                        <input
                          type="radio"
                          name="subLengthOpts"
                          id={"subLengthOpts_subject_" + index}
                          className="HiddenInput"
                          checked={packageObj.selected}
                          onClick={() => selectPackage(packageObj.packageID, index)}
                        />
                        <label className="CustomInput" htmlFor={'subLengthOpt1'}>{packageObj.name}</label>
                      </label>             
                    </div>                      
                  );                    
                })}
              </>
            }
          </div>
        </div>
      </div>

      <div className="LineSpacer5"></div>

      <div className="TotalDetails">
        <button
          className="Btn BtnOrange"
          type="submit"
          onClick={onContinue}
          disabled={selectedPackageIds.length === 0}
        >
          {AppPath.NEW_FREE_TRIAL ? 'Submit' : 'Continue'}
        </button>
      </div>
    </>
  );
};
